import axios from 'axios';

export const getProducts = (type) => axios.get(`product/listing?type=${type}`);

export const getUsersUsedProducts = (productId) =>
  axios.get(`inventory/org-transferred-users?product_id=${productId}`);

export const getTransfersInventory = () => axios.get('inventory/transfers');

export const getUserTransferInventory = (transferCode) =>
  axios.get(`inventory/transfer-users-inventory?transfer_code=${transferCode}`);
